import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconAdd$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconAdd extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c3498af223ec032257bd3ef6e62f5b60f477c1f4', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '54078ac599fcf983440c34a40a898c95e4baa681', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4157a479b599ab84f84d410e6a7ef582d79a7b81', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9m0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m.75 6.75h3.75a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3.75v3.75a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-3.75H6.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h3.75V6.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-add", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-add"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-add":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconAdd$1);
            }
            break;
    } });
}

const CosmosIconAdd = CosmosIconAdd$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconAdd, defineCustomElement };
